<template>
<div>
  <div>
    <div class="columns">
      <div class="column">
        <select-input
          :value="secondaryScraper.type"
          @input="updateType"
          :items="scraperTypes"
          label-key="short_name"
          value-key="key">
          Scraper Type
        </select-input>
      </div>
    </div>

    <scraper-type-information 
      v-if="scraperType"
      :scraper-type="scraperType"
      :pipeline-input-type="lastReturnType"
    />

    <component 
      v-if="scraperType && scraperType.builder_input"
      :is="'scraper-input-builder-' + scraperType.builder_input"
    />

    <div class="columns">
      <div class="column">
        <action-button 
          @click="storeScraper">
          Store Scraper
        </action-button>
      </div>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { storeSecondaryAttributeScraper } from '@/api/super'
import { find, last } from 'lodash'
import ScraperTypeInformation from './partials/ScraperTypeInformation.vue'

export default {

  components: {
    ScraperTypeInformation
  },

  props: {
    scraper: {
      type: Object,
      default: () => (new Scraper())
    },
    scraperTypes: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    
  }),
  
  methods: {
    ...mapMutations('secondaryScraper', [
      'updateType'
    ]),
    storeScraper() {
      storeSecondaryAttributeScraper({
        attributeId: this.attributeType.id,
        scraperId: this.scraper.id,
        handler: this.scraperType.key,
        scraper_payload: this.secondaryScraper.scraper_payload,
      }, ({data}) => {

      }, error => {
        
      })
    }
  },

  computed: {
    ...mapGetters('secondaryScraper', [
      'secondaryScraper'
    ]),
    ...mapGetters('attributeType', [
      'attributeType'
    ]),
    scraperType() {
      return find(this.scraperTypes, type => type.key === this.secondaryScraper.type)
    },
    lastReturnType() {
      if(this.scraper.secondary_scrapers.length) {
        return last(this.scraper.secondary_scrapers).return_value
      }
      return this.scraper.scraper.return_value
    }
  }

}
</script>